import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerWorkorderTitleComponent } from '../drawers/drawer-workorder-title/drawer-workorder-title.component';
import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { WorkOrdersRepository } from '../workorders.repository';
import { WorkOrderDto } from 'src/api';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DrawerWorkorderActionsComponent } from '../drawers/drawer-workorder-actions/drawer-workorder-actions.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-workorder-extra-time',
  standalone: true,
  templateUrl: './workorder-extra-time.component.html',
  styleUrls: ['./workorder-extra-time.component.scss'],
  imports: [
    CommonModule,
    DrawerWorkorderTitleComponent,
    MatButtonModule,
    NgxMatTimepickerModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    DrawerWorkorderActionsComponent,
    TranslateModule,
  ],
})
export class WorkorderExtraTimeComponent implements OnInit {
  managementTime: FormControl = new FormControl(0);
  transportTime: FormControl = new FormControl(0);

  get workOrder() {
    return this.data.workOrder;
  }

  constructor(
    public drawerRef: MtxDrawerRef<WorkorderExtraTimeComponent>,
    public workOrdersRepository: WorkOrdersRepository,
    @Inject(MTX_DRAWER_DATA) public data: { workOrder: WorkOrderDto }
  ) {}

  ngOnInit() {
    if (this.workOrder.managementExtra) {
      this.managementTime.setValue(this.workOrder.managementExtra);
    }
    if (this.workOrder.transportExtra) {
      this.transportTime.setValue(this.workOrder.transportExtra);
    }
  }

  close() {
    this.drawerRef.dismiss();
  }

  saveWorkOrderExtraTime() {
    this.workOrdersRepository.updateWorkOrderExtraTime(
      this.workOrder.id as number,
      this.managementTime.value,
      this.transportTime.value
    );
    this.drawerRef.dismiss();
  }

  managementTimeChange() {
    if (!this.managementTime.value) {
      this.managementTime.setValue(0);
    }
  }

  transportTimeChange() {
    if (!this.managementTime.value) {
      this.transportTime.setValue(0);
    }
  }
}
